import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { useParams } from 'react-router-dom'
import InnerLoading from '../ui/InnerLoading'
import { FiSearch } from "react-icons/fi"
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import { clearFilterResults, filterAdminTrips } from '../../features/admin/adminTripBookingSlice'
import TripBookingCards from './TripBookingCards'

const UserTripBooking = () => { 
    const { userId } = useParams()
    const { t } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { filterBookingResult, loading } = useSelector((state: RootState) => state.adminTripBookingSlice)

    const [search, setSearch] = useState("")
    const [statusFilter, setStatusFilter] = useState("all")
    const [checkInFilter, setCheckInFilter] = useState<Date | null>(null)
    const [checkOutFilter, setCheckOutFilter] = useState<Date | null>(null)

    useEffect(() => {
        dispatch(filterAdminTrips({ userId }))
          return () => {
    dispatch(clearFilterResults());
  };
    }, [dispatch, userId])

    if (loading) return <InnerLoading />

    if (filterBookingResult.length === 0) {
        return (
            <div className="w-full flex-center flex-col text-center mt-20">
                <img src="/asset/empty.png" alt="" className="w-48 mb-4" />
                <p className="text-gray-600">{t("no-bookings")}</p>
            </div>
        )
    }

    // filter local in frontend to reduce send to backend requests
    const filteredBookings = filterBookingResult.filter((booking: any) => {
        const matchSearch =
            booking.userName.toLowerCase().includes(search.toLowerCase()) ||
            booking.id.toString().includes(search)
        const matchStatus =
            statusFilter === "all" ? true : booking.status === statusFilter
        return matchSearch && matchStatus
    })

    // filter from backend
    const handleFilterSubmit = () => {
        dispatch(
            filterAdminTrips({
                userId,
                checkIn: checkInFilter ? checkInFilter.toISOString() : undefined,
                checkOut: checkOutFilter ? checkOutFilter.toISOString() : undefined,
            })
        )
    }

    return (
        <div className="my-10">
            {/* هيدر */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6">
                <h2 className="text-2xl font-bold">
                    {t("a-books")} {t("trips")}  {filterBookingResult[0]?.userName}
                </h2>
                <p className="text-sm opacity-80 mt-1">
                    {t("total-bookings")}: {filteredBookings.length}/{filterBookingResult.length}
                </p>
            </div>

            {/* أدوات التحكم */}
            <div className="bg-white rounded-xl shadow-sm p-4 mb-8 flex flex-col sm:flex-row gap-3 items-stretch sm:items-center flex-wrap">
                {/* بحث */}
                <div className="relative flex-1 min-w-[200px]">
                    <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder={t("search-user") as string}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="pl-10 pr-3 py-2 border rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                </div>

                {/* فلترة الحالة */}
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                    <option value="all">{t("All Statuses")}</option>
                    <option value="Pending">{t("Pending")}</option>
                    <option value="Approved">{t("Approved")}</option>
                    <option value="Returned">{t("Returned")}</option>
                    <option value="Cancelled">{t("Cancelled")}</option>
                    <option value="Paid">{t("Paid")}</option>
                    <option value="Waiting">{t("Waiting")}</option>
                </select>

                <DatePicker
                    selected={checkInFilter}
                    onChange={(date) => setCheckInFilter(date)}
                    placeholderText={t("check-in") as string}
                    className="px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    dateFormat="yyyy-MM-dd"
                />
                <DatePicker
                    selected={checkOutFilter}
                    onChange={(date) => setCheckOutFilter(date)}
                    placeholderText={t("check-out") as string}
                    className="px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    dateFormat="yyyy-MM-dd"
                />

                <button
                    onClick={handleFilterSubmit}
                    className="bg-primary hover:bg-[#00470f] text-white px-4 py-2 rounded-lg text-sm"
                >
                    {t("search")}
                </button>
            </div>

            <TripBookingCards bookings={filteredBookings} />
        </div>
    )
}

export default UserTripBooking
